"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isElement;
// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}